import axios from 'utils/axios';

// Get all clients
export const getAllClients = async ({
    perPage = 10,
    pageNo = 1,
    query = '',
    showDisabled = false,
    tags = [],
    startDate = '',
    endDate = '',
    isTrial = false,
    sortField = '',
    sorting = '',
    showOnlyInactive = false,
    showOnlyDeidentified = false
}) => {
    const formattedTags = tags.toString();
    const response = await axios.get(`clients`, {
        params: {
            perPage,
            pageNo,
            showDisabled,
            query,
            tags: formattedTags,
            startDate,
            endDate,
            isTrial,
            sortField,
            sorting,
            showOnlyInactive,
            showOnlyDeidentified
        }
    });
    return response.data;
};

// Get clients summary, active, inactive and new deployments
export const getClientSummary = async (showTrial = false) => {
    const response = await axios.get(`clients/summary`, { params: { isTrial: showTrial } });
    return response.data;
};

// delete deployment
export const deleteDeployment = async (deployment) => {
    try {
        const response = await axios.delete(`clients/delete/${deployment}`);
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

// get client info via deployment
export const getClientInfo = async (deployment) => {
    const response = await axios.get(`clients/details`, { params: { deployment } });
    return response.data;
};

// update quiz and system settings
export const updateClientSystemSettings = async (data) => {
    const response = await axios.post(`clients/settings`, { ...data });
    return response.data;
};
// update organisation settings
export const updateClientOrganisationSettings = async (data) => {
    const response = await axios.post(`clients/organisation`, { ...data });
    return response.data;
};

// update deployment logo
export const updateClientLogo = async (deployment, file) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post(`clients/logo/${deployment}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
};

// add deployment payment information
export const addPaymentInfo = async (deployment, data) => {
    const response = await axios.post(`clients/payments/${deployment}`, { ...data });
    return response.data;
};

// add deployment notes
export const addNote = async (deployment, data) => {
    const response = await axios.post(`clients/notes/${deployment}`, { ...data });
    return response.data;
};

// edit deployment notes
export const editNote = async (deployment, data) => {
    const response = await axios.put(`clients/notes/${deployment}`, { ...data });
    return response.data;
};

// delete deployment notes
export const deleteNote = async (deployment, id) => {
    const response = await axios.delete(`clients/notes/${deployment}/${id}`);
    return response.data;
};

// get all deployment users
export const deploymentUsers = async (deployment) => {
    const response = await axios.get(`clients/users/${deployment}`);
    return response.data;
};

// toggle user active
export const toggleUser = async (deployment, data) => {
    try {
        const response = await axios.post(`clients/users/status/${deployment}`, { ...data });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

// create new deployment user
export const addNewDeploymentUser = async (deployment, data) => {
    try {
        const response = await axios.post(`clients/users/${deployment}`, { ...data });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

// transfer deployment id
export const transferDeploymentId = async (source, destination) => {
    try {
        const response = await axios.post(`clients/transfer/${source}`, { deployment: destination });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

// process reactivate deployment
export const processReactivateDeployment = async (deployment) => {
    try {
        const response = await axios.post(`clients/reactivate/${deployment}`);
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

// process de identify deployment
export const processDeIdentifyDeployment = async (deployment) => {
    try {
        const response = await axios.post(`clients/deidentify/${deployment}`);
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

// process notify client contact and users
export const processNotifyClient = async (deployment) => {
    try {
        const response = await axios.post(`clients/notify/${deployment}`);
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};
